export const ACCOUNT = {
    SET_SOCIETES: 'ACCOUNT_SET_SOCIETES',
    RESET: 'ACCOUNT_RESET'
};
